import { observer } from "mobx-react-lite";
import cls from "classnames";

const TextTab = ({
  main_text,
  additional_text,
  contact_us_text,
  enable_contact_us_button,
}) => {
  const getString = (value) => {
    if (!value) return ""; // Handle null/undefined
    if (typeof value === "string") return value; // Already a string
    if (typeof value === "object" && value.en) return value.en; // Extract from object
    return ""; // Default fallback
  };

  return (
    <div className="flex flex-col gap-8">
      {" "}
      {/* className="flex flex-col gap-8 lg:flex-row" */}
      <div
        className={cls("wysiwyg max-md:px-5", {
          "max-w-[900px] lg:w-full": !additional_text && !contact_us_text,
          "lg:w-2/3": !additional_text,
          "lg:w-1/3": Boolean(additional_text),
        })}
        dangerouslySetInnerHTML={{ __html: getString(main_text) }}
      />
      <div className="flex h-[1px] w-full bg-light-grey md:hidden" />
      <div
        className="wysiwyg max-md:px-5"
        dangerouslySetInnerHTML={{ __html: getString(additional_text) }}
      />
      {Boolean(contact_us_text) && (
        <div className="lg:w-1/3">
          <div className="w-full rounded bg-light-grey px-5 py-10 md:p-10">
            <div
              className="wysiwyg"
              dangerouslySetInnerHTML={{ __html: getString(contact_us_text) }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default observer(TextTab);
